export const COLORS = {
  ORANGE: "ORANGE",
  ECSTASY: "ECSTASY",
  PINK: "PINK",
  SKYBLUE: "SKYBLUE"
};

export type Color = keyof typeof COLORS;

export const SIZES = {
  SMALL: "SMALL",
  MEDIUM: "MEDIUM"
};

export type Size = keyof typeof SIZES;
